import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si mi hijo acaba de ser diagnosticado?',
  a: 'Sí. El Tomo 1 está diseñado específicamente para padres que acaban de recibir el diagnóstico y no saben por dónde empezar. Es el punto de partida perfecto.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibes un email con el enlace de descarga. En menos de 5 minutos tienes todo en tu dispositivo.'
}, {
  q: '¿Funciona si mi hijo toma medicación?',
  a: 'Sí. El sistema es complementario a cualquier tratamiento médico o terapéutico. No sustituye al profesional, potencia lo que ya estás haciendo.'
}, {
  q: '¿Qué lo diferencia de los libros de TDAH que hay en Amazon?',
  a: 'Los libros de Amazon te explican el problema. Cherub Agency te da el protocolo exacto para resolverlo. No es teoría. Es el paso 1, el paso 2 y el paso 3 para mañana por la mañana.'
}, {
  q: '¿Tiene garantía real?',
  a: '100%. 7 días. Si no estás satisfecho/a te devolvemos cada céntimo sin hacer ninguna pregunta.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-surface-gray py-12 px-6" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <div className="text-center mb-8" data-id="element-85">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-primary" data-id="element-86">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-3" data-id="element-87">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-88">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full text-left px-5 py-4 flex items-center justify-between focus:outline-none" data-id="element-89">
                <span className="font-bold text-primary text-lg pr-4" data-id="element-90">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-91" />
              </button>
              <AnimatePresence data-id="element-92">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-93">
                    <div className="px-5 pb-4 text-[#333333] leading-relaxed border-t border-gray-50 pt-3" data-id="element-94">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}